import { Action, createReducer, on } from '@ngrx/store';
import { ILegalEntitiesCreateBusinessRequest } from '../models/create-business.model';
import * as actions from '../actions';

export const createBusinessesFeatureKey = 'createBusinesses';

export interface CreateBusinessesState {
  loadLegalEntitiesCreateBusinessRequest: ILegalEntitiesCreateBusinessRequest;
  loadLegalEntitiesCreateBusinessResponse: string;
  loadLegalEntitiesCreateBusinessFailure: Error | any;
}

export const initialState: CreateBusinessesState = {
  loadLegalEntitiesCreateBusinessRequest: undefined,
  loadLegalEntitiesCreateBusinessResponse: undefined,
  loadLegalEntitiesCreateBusinessFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadCreateBusiness, (state, action) => ({
    ...state,
    loadLegalEntitiesCreateBusinessRequest: action.request
  })),
  on(actions.loadCreateBusinessSuccess, (state, action) => ({
    ...state,
    loadLegalEntitiesCreateBusinessResponse: action.response
  })),
  on(actions.loadCreateBusinessFailure, (state, action) => ({
    ...state,
    loadLegalEntitiesCreateBusinessFailure: action.error
  }))
);

export const getCreatedLegalEntity = (state: CreateBusinessesState) => state.loadLegalEntitiesCreateBusinessResponse;
